import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'kgb'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const employeeList = 'Kepegawaian/KGB/optionListEmployee/'
export const getSalaryEmployee = 'Kepegawaian/KGB/getSalaryEmployee/'

export const kgbPeriodCreate = 'Kepegawaian/KGB/createPeriod/'
export const kgbPeriodList = 'Kepegawaian/KGB/listPeriod/'
export const kgbPeriodDetail = 'Kepegawaian/KGB/detailPeriod/'
export const kgbPeriodInactive = 'Kepegawaian/KGB/deletePeriode/'
export const kgbPeriodActive = 'Kepegawaian/KGB/activePeriod/'
export const generatePegawai = 'Kepegawaian/KGB/generatePegawai/'

export const kgbList = 'Kepegawaian/KGB/listEmployee/'
export const kgbInactive = 'Kepegawaian/KGB/inactive/'
export const kgbActive = 'Kepegawaian/KGB/active/'
export const kgbExportUsulan = 'Kepegawaian/KGB/exportExcelUsulan/'
export const kgbExportLampiran = 'Kepegawaian/KGB/exportExcelLampiran/'
export const kgbProcess = 'Kepegawaian/KGB/process/'
export const kgbDetail = 'Kepegawaian/KGB/detail/'
export const kgbDownloadDraftSK = 'Kepegawaian/KGB/DownloadDraftSK/'
export const kgbUploadSK = 'Kepegawaian/KGB/uploadSK/'
export const kgbCreateManual = 'Kepegawaian/KGB/createManual/'
export const kgbInputSK = 'Kepegawaian/KGB/inputSK/'

export const createSKCollective = 'Kepegawaian/KGB/createSKCollective/'
export const listSKCollective = 'Kepegawaian/KGB/listSKCollective/'
export const downloadSKCollective = 'Kepegawaian/KGB/downloadSKCollective/'
export const signatoriesList = 'Kepegawaian/KGB/optionListSignatories/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}